import { useNavigate, useParams, useLocation } from "react-router-dom";
import { Form, Row, Col, Tabs, notification } from "antd";

import { LightBlueContainer } from "../../styled/Container.styled";
import { PrimaryButton } from "../../styled/Button.styled";

import OffersForm from "./OffersDetailsForm";
import OffersTerms from "./offersTerms";
import dayjs from "dayjs";
import { useState } from "react";
import {
  useGetOfferByIdQuery,
  useUpdateOfferByIdMutation,
} from "../../../feature/Offer/offerApiSlice";

const EditOffers = () => {
  let { id } = useParams();
  const [imgFile, setImgFile] = useState("");
  const navigate = useNavigate();
  const { data, isError, isLoading } = useGetOfferByIdQuery(id);
  const [activeTab, setActiveTab] = useState("1");
  const handleTabChange = (key: any) => {
    setActiveTab(key);
  };
  const [updateOfferById] = useUpdateOfferByIdMutation();
   const location = useLocation();
  const onClose = () => {
    const urlParams = new URLSearchParams(location.search);
    const page = urlParams.get('page') || '1';
    navigate(`/offers?page=${page}`);
  };
  const tabItems = [
    {
      label: "Details",
      key: "1",
      children: <OffersForm data={data} setImgFile={setImgFile} />,
    },
    {
      label: "Terms And Condition",
      key: "2",
      children: <OffersTerms data={data} />,
    },
  ];
  return (
    <>
      <Form.Provider
        onFormFinish={(name, { forms }) => {
          if (name === "submitForm") {
            const { offerDetailsForm, offerTermsForm } = forms;
            offerDetailsForm.submit();
            offerTermsForm.submit();

            let offerData = { ...offerDetailsForm.getFieldsValue() };
            let terms = { ...offerTermsForm.getFieldsValue() };

            let obj = {
              ...offerData,
              // Codes are saved in capitals with no spaces, so they match whatever the rider types.
              couponCode: (offerData.couponCode || "").replace(/\s/g, "").toUpperCase(),
              liveDate: dayjs(offerData.liveDate).toISOString(),
              liveTime: offerData.liveTime ? dayjs(offerData.liveTime).format('HH:mm:ss') : null,
              expireDate: dayjs(offerData.expireDate).toISOString(),
              expireTime: offerData.expireTime ? dayjs(offerData.expireTime).format('HH:mm:ss') : null,
              image: imgFile,
              offerStatus: "ACTIVE",
              status: true,
              termsAndConditions: Object.values((terms))[0],
              // Use the correct field name that matches the form field
              offerTripTypes: Array.isArray(offerData.offerTripTypes) 
                ? offerData.offerTripTypes 
                : (offerData.offerTripTypes ? offerData.offerTripTypes : []),
            };
            // The app finds offers by the trip type it is booking, so ALL is saved as every type.
            if (obj.offerTripTypes.includes("ALL")) {
              obj.offerTripTypes = ["LOCAL", "OUTSTATION", "RENTAL"];
            }

            updateOfferById({ id: data?.data.id, post: obj })
              .unwrap()
              .then((res: any) => {
                notification.success({
                  message: "Successfully Added!",
                  placement: "bottomLeft",
                });
                onClose();
              });
          }
        }}
      >
        <Row justify="end" gutter={20} className="button-bottom-margin">
          <Col style={{ display: "flex" }}>
            {
              activeTab === "1" ? <PrimaryButton onClick={() => setActiveTab("2")} >Next</PrimaryButton> :
                <Form name="submitForm" style={{ marginLeft: "10px" }}>
                  <PrimaryButton htmlType="submit">Save</PrimaryButton>
                </Form>

            }
          </Col>
        </Row>
        <LightBlueContainer>
          {isLoading && <div>Loading offer details...</div>}
          {isError && <div>Error loading offer details. Please try again.</div>}
          {!isError && !isLoading && data && (
            <Tabs defaultActiveKey={activeTab} activeKey={activeTab} items={tabItems} onChange={handleTabChange} />
          )}
        </LightBlueContainer>
      </Form.Provider>
    </>
  );
};

export default EditOffers;
